import script from "./URadios.vue?vue&type=script&setup=true&lang=js"
export * from "./URadios.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__